module.exports = __webpack_public_path__ + "img/asousa.5addc6de.png";